import React, { useState, useEffect } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import Cta from "~components/Cta";
import MyForm from "./CreateForm";
import WalletLayout from "../components/WalletLayout";
import useHeader from "~components/Header/hooks/useHeader";
import { initialPath } from "~misc/paths";
import CreateForm from "./CreateForm";
import { useConfigureFooter } from "~hooks/useHelpers";

const Sender = () => {
  const { parameter } = useParams();
  const { path } = useHeader();

  const [backRoute, setBackRoute] = useState(null);

  useConfigureFooter({ form: true, formId: "emissor", backRoute }, [backRoute])

  return (
    <WalletLayout>
      <Cta title="Emissor" />
      <CreateForm setBackRoute={setBackRoute} />
    </WalletLayout>
  );
};

export default Sender;
